import type { Networkish } from "@/types";
import { useMemo } from "react";

import useSupportedChains, { type SupDicChainData } from "@/hooks/api/useSupportedChains";

export default function useChainInfo(chain?: Networkish): { data: SupDicChainData | undefined; isLoading: boolean; isError: boolean; error: Error | undefined } {
  const { data, isLoading, isError, error } = useSupportedChains(Boolean(chain));

  const chainName = `${chain}`.toLowerCase();
  let chainId = undefined as number | undefined;

  try {
    chainId = chain ? parseInt(chain.toString()) : undefined;
  } catch (e) {
    chainId = undefined;
  }

  return useMemo(() => {
    const result = data?.find(c => (chainId ? c.chain_id === chainId : c.name.toLowerCase() === chainName));

    return {
      data: result,
      isLoading,
      isError: isError || (data !== undefined && result === undefined),
      error: error || (data !== undefined && result === undefined) ? new Error(`Chain ${chain} not found`) : undefined,
    };
  }, [data, isLoading, isError, error, chain, chainId, chainName]);
}
